import { useQuery } from '@tanstack/react-query';
import { apiFetch } from './client.js';
import type { MonitorData } from './types.js';

/**
 * The staff monitor snapshot. Polls every 8s while `auto` is on (kept up to date
 * even in a background tab, so it works as a wall/tablet display).
 */
export function useMonitor(auto: boolean) {
  return useQuery({
    queryKey: ['monitor'],
    queryFn: () => apiFetch<{ monitor: MonitorData }>('/projects/monitor').then((r) => r.monitor),
    refetchInterval: auto ? 8000 : false,
    refetchIntervalInBackground: true,
  });
}
